const toAmount = (value) => {
  const parsed = parseFloat(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const FULLY_PAID_MESSAGE =
  'The student fees are cleared. You cannot make any further payment.';

export const getStudentGrossTotal = (student = {}) =>
  toAmount(student.gross_total);

export const getStudentPendingAmount = (student = {}) =>
  Math.max(0, toAmount(student.pending_amount));

export const isStudentFullyPaid = (student = {}) =>
  getStudentPendingAmount(student) <= 0;
